const title = "Rental Affordability Index (2017)";

const intros = [
  {
    text: "This study illustrates the price of renting per square foot in 33 London boroughs, 15 UK cities and 72 cities worldwide. Based on this, the research could further convey the minimum gross salary required to support an individual and a family of four in rented property, based on the minimum space recommended for one person, and for a family.",
    id: "rental-intro-1",
  },
  {
    text: "The comprehensive study was undertaken in order to understand the costs associated with renting as an individual and as a family, and to determine whether cities are becoming increasingly unaffordable. The inclusion of specific results for each of the 33 London boroughs allows easy comparison between regional and global cities to the UK capital, with its much-publicised unaffordability.",
    id: "rental-intro-2",
  },
  {
    text: (
      <span>
        The price per square foot of property was calculated based upon current
        market listings for all locations researched, whilst the minimum space
        recommended for one person and four people is laid out in guidelines
        from the Greater London Authority.
        <sup>1</sup>
        The gross salary guideline was included to help illustrate relative
        affordability.
        <sup>2</sup>
      </span>
    ),
    id: "rental-intro-3",
  },
];

const topButtons = [
  {
    text: "UK",
    country: "uk",
    countryUrl: "uk/london",
  },
  {
    text: "US",
    country: "us",
    countryUrl: "us/all",
  },
  {
    text: "Global",
    country: "global",
    countryUrl: "global/all",
  },
];

const footnotes = [
  {
    text: (
      <span>
        <sup>1</sup> Housing standards published by the Greater London Authority
        states that 420 square feet is the minimum living space recommended for
        one person and 797 square feet is the minimum living space recommended
        for four people, sourced from:
        https://www.london.gov.uk/sites/default/files/housing_standards_malp_for_publication_7_april_2016.pdf
      </span>
    ),
    id: "rental-footnote-1",
  },
  {
    text: (
      <span>
        <sup>2</sup> A report published by Loughborough University Institutional
        Repository purports that no more than 29% of one’s gross salary should
        be spent on rent per month, sourced from:
        https://dspace.lboro.ac.uk/dspace-jspui/bitstream/2134/20683/1/households_below_a_minimum_income_standard_2008_9_to_2013_14.pdf
      </span>
    ),
    id: "rental-footnote-2",
  },
  {
    text: (
      <span>
        <sup>3</sup>
        The figure for London in the global cities list is based on an average
        of the 33 boroughs taken from the London ranking.
      </span>
    ),
    id: "rental-footnote-3",
  },
];

export const addAdditionalContent = (content) => ({
  ...content,
  title,
  topButtons,
  intros: [...intros, ...(content.intros || [])],
  footnotes,
});
